var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 25,
    fill: "none",
    viewBox: "0 0 18 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.026 15.078A2.026 2.026 0 119 13.052a2.032 2.032 0 012.026 2.026z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14.064 9V6.974A5.016 5.016 0 009 1.909a5.015 5.015 0 00-5.065 5.065V9h10.13zm1.013 12.155H2.922a1.014 1.014 0 01-1.013-1.013v-10.13A1.013 1.013 0 012.922 9h12.155a1.013 1.013 0 011.013 1.013v10.129a1.013 1.013 0 01-1.013 1.013v0z"
  })));
};
export default SvgPadlock;